import type { ChipProps } from '@mui/material'
import { Chip } from '@mui/material'
import React from 'react'

interface StyledChipProps extends ChipProps {
  label: React.ReactNode
}

const StyledChip: React.FC<StyledChipProps> = ({ label, ...props }) => {
  return (
    <Chip
      label={label}
      sx={theme => ({
        margin: theme.spacing(0.5),
        height: 'auto',
        whiteSpace: 'wrap',
        '& .MuiChip-label': {
          whiteSpace: 'wrap',
          wordBreak: 'break-word',
        },
      })}
      {...props}
    />
  )
}

export default StyledChip
